<template>
    <v-dialog
        v-model="activate"
        max-width="400px"
        overlay-opacity=.05
        persistent
        content-class="profile-dialog"
    >
        <v-card class="neu-glow">
            <v-card-title class="pa-2 mb-1">
                <vuse-section-definition
                    :title="$t('Global.Profile.userProfile')"
                    icon="mdi-account"
                ></vuse-section-definition>
            </v-card-title>
            <v-card-text class="pa-2 mb-4">
                <v-row class="ma-0 mb-n8">
                    <v-col cols="6">
                        <v-list-item two-line class="mx-3">
                            <v-list-item-content>
                                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Profile.firstName') }}</p></v-list-item-title>
                                <v-list-item-subtitle><p>{{ getUserName }}</p></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="mx-3">
                            <v-list-item-content>
                                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Profile.lastName') }}</p></v-list-item-title>
                                <v-list-item-subtitle><p>{{ getUserLastName }}</p></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
                <v-row class="ma-0 mb-n8">
                    <v-col cols="6">
                        <v-list-item two-line class="mx-3">
                            <v-list-item-content>
                                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Profile.company') }}</p></v-list-item-title>
                                <v-list-item-subtitle><p>{{ getCompanyName }}</p></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item two-line class="mx-3">
                            <v-list-item-content>
                                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Profile.role') }}</p></v-list-item-title>
                                <v-list-item-subtitle><p>{{ getRoleName }}</p></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
                <v-row class="ma-0 mb-n4">
                    <v-col>
                        <v-list-item two-line class="mx-3">
                            <v-list-item-content>
                                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Profile.email') }}</p></v-list-item-title>
                                <v-list-item-subtitle>
                                    <p>{{ getUserEmail }}
                                        <v-icon class="ml-6" dense color="primary" @click="changeDialog=true">mdi-square-edit-outline</v-icon>
                                    </p>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-row class="mx-1 mb-3 d-flex justify-space-between">
                    <v-btn color="blue darken-1" text @click="changePasswordDialog = true"> {{ $t('Global.Profile.changePassword') }} </v-btn>
                    <v-btn color="blue darken-1" text @click="$emit('close-profile')"> {{ $t('Global.Profile.close') }}</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <change-mail-dialog
            :changeDialog= "changeDialog"
            @close-dialog="changeDialog=false"
            @close-all="$emit('close-profile')"
            @reload-profile="updateUser()"
        />
      <profile-change-password-dialog
          :changePasswordDialog= "changePasswordDialog"
          @close-dialog="changePasswordDialog=false"
          @close-all="$emit('close-profile')" />
    </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ChangeMailDialog from '@/components/UI/Dialogs/ChangeMailDialog'
import ProfileChangePasswordDialog from '@/components/UI/Dialogs/ProfileChangePasswordDialog'
import UserInfoApi from "@/mixins/Services/UserInfoApi"
import loader from "@/mixins/Loader";

export default {
    name: "ProfileCard",
    components: {
        ChangeMailDialog,
      ProfileChangePasswordDialog
    },
    mixins: [UserInfoApi, loader],
    props: {
        activate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            changeDialog: false,
            changePasswordDialog: false
        }
    },
    computed: {
        ...mapGetters(["getUserName","getUserLastName","getCompanyName","getRoleName","getUserEmail"]),
    },
    methods: {
        ...mapActions(["setUser"]),
        changePassword() {
            console.log('change password');
        },
        async updateUser() {
            try {
                //this.setLoader(true)
                const respUserInfo = await this.getUserInfo()
                console.log(respUserInfo);
                this.setUser(respUserInfo)
                //this.setLoader(false)
            }
            catch(e) {
                //this.setLoader(false)
            }
        }

    },
    created(){
        this.updateUser()
    }
}
</script>
